import Styleguide from './Styleguide';

export default Styleguide;
